import { createSlice } from '@reduxjs/toolkit';
import storage from '@/shared/utils/storage';

const initialState = {
   step: storage.getItem('auth_flow') || 'signin',
};

const authSlice = createSlice({
   name: 'auth',
   initialState,
   reducers: {
      setAuthStep: (state, action) => {
         state.step = action.payload;
      },
      resetAuthFlow: state => {
         state.step = 'signin';
      },
   },
});

export const { setAuthStep, resetAuthFlow } = authSlice.actions;
export const authReducers = { auth: authSlice.reducer };
export default authSlice.reducer;
